export default __webpack_public_path__ + "static/media/dispenser bottle.994bb2e2.jpeg";